import { render, staticRenderFns } from "./thirdpartyPayment.vue?vue&type=template&id=f50020f8&scoped=true"
import script from "./thirdpartyPayment.vue?vue&type=script&lang=js"
export * from "./thirdpartyPayment.vue?vue&type=script&lang=js"
import style0 from "./thirdpartyPayment.vue?vue&type=style&index=0&id=f50020f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50020f8",
  null
  
)

export default component.exports